export const home = {
  heroTitle: 'Physical Gold',
  heroSubtitle: 'Spot Reservation',
  heroMainTitle: 'Every Order Matches Physical Gold',
  heroTitleLine1: 'Physical Gold, Transparent & Traceable',
  heroTitleLine2: 'Safe & Secure, Wealth Heritage',
  heroSubTags: 'Physical Gold · Traceable · Secure',
  heroDesc: 'Lock in the price at the daily gold rate and withdraw physical gold upon maturity',
  heroCta: 'Lock Price Now',
  productLabel: 'Investment Gold Bar',
  productWeight: '50g',
  productBrand: 'Au9999',
  guaranteePhysicalGold: 'Physical Guarantee',
  guaranteePhysicalGoldDesc: '100% Real Gold',
  guaranteeAuthority: 'Authority Certified',
  guaranteeAuthorityDesc: 'Certified | Quality Assured',
  guaranteeTransparency: 'Safe & Transparent',
  guaranteeTransparencyDesc: 'Open Info | Compliant',
  physicalGuaranteeBadge: 'Physical Guarantee',
  realGold: 'REAL GOLD',
  liveGoldPrice: 'Live Price (Au9999)',
  liveUpdate: 'Live Update',
  todayChange: "Today's Change",
  moreMarket: 'More Market',
  marketRefTitle: 'Market Reference',
  shGoldExchange: 'Shanghai Gold Exchange Au9999',
  shSilverExchange: 'Shanghai Silver Exchange Ag9999',
  todayGoldRef: "Today's Gold Reference",
  todaySilverRef: "Today's Silver Reference",
  quickReserve: 'Quick Reserve',
  reserveOrders: 'Reserve Orders',
  performManage: 'Performance Mgmt',
  performPay: 'Performance Pay',
  quickReserveDesc: 'Lock price instantly',
  reserveOrdersDesc: 'Track progress anytime',
  performManageDesc: 'Physical guarantee assured',
  performPayDesc: 'Safe and convenient',
  jinanPromise: 'Jinan Promise',
  promiseValues: 'Professional · Integrity · Safe · Transparent',
  promiseSubtitle: 'Your gold assets, entrusted to Jinan China',
  marketRefAu: 'Market Reference Au9999',
  marketRefAg: 'Market Reference Ag9999',
  noticeTitle: 'Jinan Notices',
  serviceGuarantee: 'Reservation Service · Physical Guarantee',
  guaranteeSecurity: 'Security',
  guaranteeSecurityDesc: 'Bank-level security system',
  guaranteeTransparent: 'Transparent',
  guaranteeTransparentDesc: 'Real-time market transparency',
  guaranteePhysical: 'Physical Delivery',
  guaranteePhysicalDesc: 'Withdraw physical gold upon maturity',
  guaranteeService: 'Professional',
  guaranteeServiceDesc: '24/7 customer service online',
  footerBrand: 'Jinan China',
  footerCopyright: '© 2026 Jinan China. Physical Gold Custody & Security Guaranteed.',
  physicalGold: 'PHYSICAL GOLD',
  spotReserve: 'Spot Reservation',
  openPrice: 'Open Price',
  currentPrice: 'Current Price',
  profitLoss: 'P&L',
  buyIn: 'Buy IN',
  sellOut: 'Sell OUT',
  originalMargin: 'Original Margin',
  currentMargin: 'Current Margin',
  deferredFee: 'Deferred Fee',
  riskLevel: 'Risk Level',
  paidIn: 'Added',
  paidOut: 'Withdrawn',
  depositRecord: 'Deposit Record',
  applyPerform: 'Apply Performance',
  addDeposit: 'Add Deposit',
  withdrawDeposit: 'Withdraw Deposit',
  closePosition: 'Close Position',
  availableMargin: 'Available Margin',
  usedMargin: 'Used Margin',
  floatingProfit: 'Floating P&L',
  longWeight: 'Long',
  shortWeight: 'Short',
  netWeight: 'Net',
  noPosition: 'No positions',
  noCloseRecord: 'No closed positions',
  positionLoadFailed: 'Failed to load positions',
  confirmDeposit: 'Confirm Add',
  confirmWithdraw: 'Confirm Withdraw',
  confirmClose: 'Confirm Close',
  cancelClose: 'Cancel',
  closeWarning: 'Closing will immediately settle P&L, and this position cannot be restored. Please carefully verify the information above before confirming.',
  depositAmount: 'Deposit Amount',
  withdrawAmount: 'Withdraw Amount',
  currentDeposit: 'Current Margin',
  availableDeposit: 'Available Deposit',
  withdrawable: 'Withdrawable Amount',
  keep10Percent: 'Must retain 10% of original margin as minimum',
  quickAmount1000: '¥1000',
  quickAmount3000: '¥3000',
  quickAmount5000: '¥5000',
  quickAmount10000: '¥10000',
  allAmount: 'All',
  maxAmount: 'Max',
  errorInvalidAmount: 'Please enter a valid amount',
  errorInsufficientFunds: 'Insufficient available deposit',
  errorMaxWithdraw: 'Maximum withdrawable: ¥{{amount}} (must retain 10% original margin)',
  expectedProfit: 'Estimated P&L',
  openPriceLabel: 'Open Price',
  closePriceLabel: 'Close Price',
  holdTab: 'Holdings',
  closeTab: 'Closed',
  selectAll: 'Select All',
};